// newsletter.js
import Layout from "components/layout/layout";
import ActivityCard from "components/activity_card/ActivityCard";
import "./firstyearstudents.css";

const firstYearStudentData = [
  {
    title: "Notice Regarding MYSY Help Centre",
    description:
      "",
    images: ["/assets/firstyearstudents/Notice Regarding MYSY Help Centre.png"],
    report: "/assets/firstyearstudents/Notice Regarding MYSY Help Centre.pdf",
  },
  {
    title: "Notice for Semester-1 Hostel New Admission Fee for Academic Year 2026-27 (Round-2)",
    description:
      "",
    images: ["/assets/firstyearstudents/Hostel_Fee_Notice_With_Payment_Process_Round-2.png"],
    report: "/assets/firstyearstudents/Hostel_Fee_Notice_With_Payment_Process_Round-2.pdf",
  },
  {
    title: "Boys Hostel Admission List 2026 (Round-2)",
    description:
      "",
    images: ["/assets/firstyearstudents/Boys_Hostel_First_Year_Admission_List_Round_2_2026-27.png"],
    report: "/assets/firstyearstudents/Boys_Hostel_First_Year_Admission_List_Round_2_2026-27.pdf",
  },
  {
    title: "Girls Hostel Admission List 2026 (Round-2)",
    description:
      "",
    images: ["/assets/firstyearstudents/Girls_Hostel_First_Year_Admission_List_Round_2_2026-27.png"],
    report: "/assets/firstyearstudents/Girls_Hostel_First_Year_Admission_List_Round_2_2026-27.pdf",
  },
  {
    title: "Notice for Hostel New Admission Fee for Academic Year 2026-27 (Semester-1)",
    description:
      "",
    images: ["/assets/firstyearstudents/hostel_admission_fee_notice_2026-27.png"],
    report: "/assets/firstyearstudents/Admission_Fee_Notice_2026_Round-1.pdf",
  },
  {
    title: "Boys Hostel Admission List 2026 (Round-1)",
    description:
      "",
    images: ["/assets/firstyearstudents/Boys_Hostel_Admission_List_2026_Round-1.png"],
    report: "/assets/firstyearstudents/Boys_Hostel_Admission_List_2026_Round-1.pdf",
  },
  {
    title: "Girls Hostel Admission List 2026 (Round-1)",
    description:
      "",
    images: ["/assets/firstyearstudents/Girls_Hostel_Admission_List_2026_Round-1.png"],
    report: "/assets/firstyearstudents/Girls_Hostel_Admission_List_2026_Round-1.pdf",
  },
  {
    title: "Hostel Admission Notice for the the Newly Admitted First Year Students (Students Admitted in Academic Year 2026-27)",
    description:
      "",
    images: ["/assets/firstyearstudents/hostel_admission_form_notice_for_sem_1.png"],
    report: "/assets/firstyearstudents/Hostel_New_Admission_Form_Notice_for_ Semester_1.pdf",
  },
  {
    title: "Hostel Admission Form for the the Newly Admitted First Year Students (Students Admitted in Academic Year 2026-27)",
    description:
      "",
    images: ["/assets/firstyearstudents/hostel_admisison_form_sem_1.png"],
    report: "/assets/firstyearstudents/Application_Form_for_Hostel_New_Admission_Semsester_1_2026-27.pdf",
  },
  {
    title: "Details of Class Coordinators for the the Newly Admitted First Year Students (Students Admitted in Academic Year 2026-27)",
    description:
      "",
    images: ["/assets/firstyearstudents/FY_CC_2026-27.png"],
    report: "/assets/firstyearstudents/FY_CC_2026-27.pdf",
  },
  {
    title: "Details of Hostel Incharge at Government Engineering College, Bhavnagar",
    description:
      "",
    images: ["/assets/firstyearstudents/hostelincharge_2026-27.png"],
    report: "/assets/firstyearstudents/hostelincharge_2026-27.pdf",
  },
  {
    title: "Provisional Bonafide Certificate and Application Format for the Newly Admitted First Year Students (Students Admitted in Academic Year 2026-27)",
    description:
      "",
    images: ["/assets/firstyearstudents/provisionalbonafide.png"],
    report: "/assets/firstyearstudents/provisional_bonafide_2026-27.pdf",
  },
  /*{
    title: "Important Notice for the Newly Admitted First Year Students (Students Admitted in Academic Year 2026-27)",
    description:
      "",
    images: ["/assets/firstyearstudents/Notice.png"],
    report: "/assets/firstyearstudents/Important Notice for the Newly Admitted First Year Students.pdf",
  },
  {
    title: "Timetable for Student Induction Program for Newly Admitted First Year Students (Students Admitted in Academic Year 2025-26)",
    description:
      "",
    images: ["/assets/firstyearstudents/TT.png"],
    report: "/assets/firstyearstudents/Timetable Student Induction Program 2025.pdf",
  },
  {
    title: "Details of Class Coordinators for the the Newly Admitted First Year Students (Students Admitted in Academic Year 2025-26)",
    description:
      "",
    images: ["/assets/firstyearstudents/CC_2025-26.png"],
    report: "/assets/firstyearstudents/FY_CC_2025-26.pdf",
  },
  {
    title: "Details of Hostel Incharge at Government Engineering College, Bhavnagar",
    description:
      "",
    images: ["/assets/firstyearstudents/hostelincharge.png"],
    report: "/assets/firstyearstudents/hostelincharge.pdf",
  },*/
];

const FirstYearStudentsPage = () => {
  return (
    <Layout
      title="Important Information for the Newly Admitted First Year Students (Admission Year: 2026-27)"
      breadcrumb={[
        { name: "Home", path: "/" },
        { name: "Important Information for First Year Students" },
      ]}
    >
      <div className="coe-page">
        {/* Static Description */}
        
        {/* Activity Cards Displaying Newsletter Items */}
        <div className="coe-labs" id="newsletters">
          <h3 className="coe-info-title">Important Information for the Newly Admitted First Year Students (Admission Year: 2026-27)</h3>
          <div className="coe-labs-list">
            <ActivityCard activities={firstYearStudentData} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FirstYearStudentsPage;
